/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import moment from 'moment';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, objectSerial, config} from 'Utils';
import {sKeylist} from '../../service/dictionary/dataitem';
import {
    getWarehouseInventoryQueryList,
    setProductUp,
    setProductDown,
    getSubStoreList
} from '../../service/product';
import {Store, Actions} from './store';

class WarehouseInventoryQuery extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            opts: ['出入库记录'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            assignWay: [],
            searchObj: {
                proCode: '',
                proName: '',
                detailCategory: '',
                assignWay: '',
                operateName: '',
                storageLocal: '',
                storage: '',
                startDate: '',
                endDate: '',
                s: 10,
                p: 1,
            },
            objType_type: [],
            objType_type2: [],
            objType_type3: [],
            categoryData: [],
            button_limits_end: {},
            loading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goView(url) {
        hashHistory.push(url);
    }

    goAdd() {
        alert('导入产品');
    }

    goDelete() {
        alert('正在删除');
    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                proCode: '',
                proName: '',
                assignWay: '',
                operateName: '',
                storageLocal: '',
                storage: '',
                startDate: '',
                endDate: '',
                detailCategory: '',
                s: 10,
                p: 1,
                sendNo: '',
            }, loading: true
        }, () => {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from + ' 00:00:00',
                    endDate: value.end + ' 00:00:00'
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    advanceSubmit(form) {
        if (!this.state.loading) {
            /* 筛选确认 */
            let self = this;
            if (this.state.searchObj.endDate == '' || this.state.searchObj.startDate == '') {
                openNotice('warning', '请选择事务处理日期');
                return;
            }

            if (this.state.searchObj.proCode != '' || this.state.searchObj.proName != '') {
                if (moment(this.state.searchObj.endDate).diff(moment(this.state.searchObj.startDate), 'day') > 366 * 3) {
                    openNotice('warning', '事务处理日期范围不能超过3年');
                    return;
                }
            } else {
                if (moment(this.state.searchObj.endDate).diff(moment(this.state.searchObj.startDate), 'day') > 366) {
                    openNotice('warning', '事务处理日期范围不能超过1年');
                    return;
                }
            }

            this.setState({
                filterBoxVisible: false,
                searchObj: {
                    ...this.state.searchObj,
                    p: 1
                }, loading: true
            }, function () {
                self.initData();
            });
        }
    };


    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    updateProductStatusFn(key) {
        /* 产品上下架 */
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        if (key == 'up') {
            setProductUp(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '上架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '上架操作失败', (result && result.message) ? result.message : '');
                }
            });
        } else {
            setProductDown(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '下架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '下架操作失败', (result && result.message) ? result.message : '');
                }
            });
        }
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        getWarehouseInventoryQueryList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        sKeylist({sKey: 'STORAGE_OUTIN'}).then(res => {
            if (res.data && res.data.length > 0) {
                let arr = [{
                    value: '',
                    text: '全部'
                }];
                res.data.forEach(x => {
                    arr.push({
                        value: x.sKey,
                        text: x.name
                    });
                });
                self.setState({assignWay: arr})
            }
        })
        // getProductCategory().then(function (categoryResult) {
        // 	/* 产品分类 */
        // 	if (!categoryResult || categoryResult.code != 200) {
        // 		openNotice('error', '产品分类数据获取失败，请重试', '');
        // 		return;
        // 	}
        // 	self.setState({
        // 		categoryData: categoryResult.data || []
        // 	});
        // });
        getSubStoreList({
            removeFlag: 0,
            s: 1000,
            p: 1,
        }).then(res => {
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.subStoreName,
                        value: x.id
                    })
                });
                self.setState({objType_type3: arr})
            }
        });
        // materialScreening().then(res => { //物料类别
        //     if(res.status){
        //         let arr = [
        //             {
        //                 text: '全部',
        //                 value: ''
        //             }
        //         ];
        //         res.data.forEach(x => {
        //             arr.push({
        //                 text: x.name,
        //                 value: x.id
        //             })
        //         });
        //         let timer = window.setInterval(function(){
        //             if(self.mounted){
        //                 window.clearInterval(timer);
        //                 self.setState({objType_type: arr})
        //             }
        //         }, 0);
        //     }
        // });
        // materialScreening2().then(res => { //物料类别
        // 	if(res.status){
        // 	    let arr = [
        // 	        {
        // 	            text: '全部',
        // 	            value: ''
        // 	        }
        // 	    ];
        // 	    res.data.forEach(x => {
        // 	        arr.push({
        // 	            text: x.name,
        // 	            value: x.id
        // 	        })
        // 	    });
        // 	    let timer = window.setInterval(function(){
        // 	        if(self.mounted){
        // 	            window.clearInterval(timer);
        // 	            self.setState({objType_type2: arr})
        // 	        }
        // 	    }, 0);
        // 	}
        // });
    }

    componentDidMount() {
        //this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/dmsTianGoodsStore/exportOutIn?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            assignWay,
            objType_type3,
            loading
        } = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'proCode',
                    label: '物料编码',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.proCode
                },
                {
                    name: 'proName',
                    label: '物料描述',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.proName
                }, {
                    name: 'assignWay',
                    label: '事务类型',
                    text: '选择事务类型',
                    options: assignWay,
                    defaultValue: '',
                    multiple: false,//支持多选
                    type: 'select'
                }, {
                    name: 'operateName',
                    label: '处理人员',
                    text: '请输入处理人员',
                    type: 'default',
                    defaultValue: searchObj.operateName
                }, {
                    name: 'orderTime',//startCreatedDate, endCreatedDate
                    label: '事务处理日期',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startDate || '',
                        end: searchObj.endDate || ''
                    },
                }, {
                    name: 'storage',
                    label: '原仓库',
                    text: '选择原仓库',
                    options: objType_type3,
                    defaultValue: searchObj.storage,
                    multiple: false,//支持多选
                    type: 'select'
                }, {
                    name: 'storageLocal',
                    label: '目标仓库',
                    text: '选择目标仓库',
                    options: objType_type3,
                    defaultValue: searchObj.storageLocal,
                    multiple: false,//支持多选
                    type: 'select'
                }, {
                    name: 'sendNo',
                    label: '事务编号',
                    text: '请输入事务编号',
                    type: 'default',
                    defaultValue: searchObj.sendNo
                }, {
                    name: 'detailCategory',
                    label: '物料类别',
                    text: '请输入物料类别',
                    type: 'default',
                    defaultValue: searchObj.detailCategory
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '事务编号',
                    dataIndex: 'sendNo',
                    width: 110,
                }, {
                    title: '单号',
                    dataIndex: 'code',
                    width: 110,
                }, {
                    title: '物料编码',
                    dataIndex: 'proCode',
                    width: 120,
                }, {
                    title: '物料描述',
                    dataIndex: 'proName',
                    width: 300
                }, {
                    title: '事务类型',
                    dataIndex: 'assignWayText',
                }, {
                    title: '物料类别',
                    dataIndex: 'detailCategory',
                }, {
                    title: '期初库存',
                    dataIndex: 'startcount',
                }, {
                    title: '期末库存',
                    dataIndex: 'endcount'
                }, {
                    title: '数量',
                    dataIndex: 'num',
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',
                }, {
                    title: '单位',
                    dataIndex: 'unitText',
                }, {
                    title: '原仓库',
                    dataIndex: 'storedStr',
                }, {
                    title: '目标仓库',
                    dataIndex: 'storingStr',
                }, {
                    title: '操作人员',
                    dataIndex: 'operateName',
                }, {
                    title: '处理日期',
                    dataIndex: 'outInTime',
                }, {
                    title: '备注',
                    dataIndex: 'remark',
                },
                {
                    title: '行备注',
                    dataIndex: 'lineRemark',
                }
            ],
            rows,
            /*rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange
            }*/
        };
        return <div>
            <DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}
;
export default withRouter(WarehouseInventoryQuery);


// WEBPACK FOOTER //
// ./src/routes/stockControl/warehouseInventoryQuery.js